import { SUMMARY_TYPE, TEXT_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types.tsx';
import type { SUPPORTED_TEXT_TYPES } from '../types.tsx';

type TextField = {
	fieldId: string;
	type: SUPPORTED_TEXT_TYPES;
	value: string | null;
};

const evaluateHandler: EvaluateHandler<TextField> = {
	IS_EMPTY: (field) => Boolean(!field.value),
	IS_NOT_EMPTY: (field) => Boolean(field.value),
	CONTAINS: (field, value) => Boolean(typeof value === 'string' && field.value?.includes(value)),
	DOES_NOT_CONTAIN: (field, value) =>
		Boolean(typeof value === 'string' && !field.value?.includes(value)),
};

const evaluateFormatRule: FormatRule<TextField> = ({ field, operator, value }) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const textEvaluateFormatRule = {
	[SUMMARY_TYPE]: evaluateFormatRule,
	[TEXT_CF_TYPE]: evaluateFormatRule,
};
